import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const DISTRIBUTION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Distribution.Name')
    .required()
    .maxLength(50)
    .build(),
];

export const DISTRIBUTION_CONFIG = {
  entityName: 'Distribution',
  localizationKey: 'Planning::Entity.Distribution',
  fields: DISTRIBUTION_FIELDS,
  permission: 'Planning.Distributions',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.OperationPlanning + MENU_NAME_SUFFIX,
};
